import { Record } from "immutable";
import { MessagePart } from "models/interfaces/conversations/message-part";

const defaultValues: MessagePart = {
    kind: undefined,
    partId: undefined,
    additionalData: undefined,
};

export default class MessagePartRecord
    extends Record(defaultValues)
    implements MessagePart
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<MessagePart>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<MessagePart>} values
     */
    public with(values: Partial<MessagePart>): MessagePartRecord {
        return new MessagePartRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
